/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.events.rpc.LearningEventSeriesRpc
 */

export const getSeriesEventsRpc = {
  serviceName: 'com.hubspot.academy.learning.events.rpc.LearningEventSeriesRpc',
  rpcName: 'getSeriesEvents',
  auth: 'app',
  fingerprint: '99PZmNvM9nJAJfe8OTPGyS86T5wPH94E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getEventSeriesRpc = {
  serviceName: 'com.hubspot.academy.learning.events.rpc.LearningEventSeriesRpc',
  rpcName: 'getEventSeries',
  auth: 'app',
  fingerprint: 'nzk_bwEpU8lcOVbfUdML0C86T5wPH94E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSeriesEventsByLanguageRpc = {
  serviceName: 'com.hubspot.academy.learning.events.rpc.LearningEventSeriesRpc',
  rpcName: 'getSeriesEventsByLanguage',
  auth: 'app',
  fingerprint: '1z6eGkO9naJAJfe8OTPGyS86T5wPH94E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};